import React from "react";
import classNames from "classnames";
import styles from "../RulesTable.module.scss";
import { TransactionRuleGroup } from "../../../../common/types/transactionRule";
import { useTypedFlags } from "../../../../hooks/useTypedFlags";
import { GroupHeaderCell } from "./GroupHeaderCell";

/**
 * EmptyState displays when a group has no rules.
 */
interface EmptyStateProps {
    readonly group: TransactionRuleGroup;
    readonly groupListeners?: React.HTMLAttributes<HTMLElement>;
    readonly groupAttributes?: React.HTMLAttributes<HTMLElement>;
    readonly highlight?: boolean;
    readonly groupIndex: number;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
    group,
    groupListeners,
    groupAttributes,
    highlight,
    groupIndex,
}) => {
    const { advancedRules } = useTypedFlags();
    return (
        <>
            <GroupHeaderCell
                group={group}
                groupListeners={groupListeners}
                groupAttributes={groupAttributes}
                groupIndex={groupIndex}
            />
            <td
                className={classNames(
                    styles.td,
                    highlight && styles.selected,
                    !advancedRules && styles.center,
                )}
                colSpan={3}
            >
                {advancedRules
                    ? "No rules in this group"
                    : "No rules created yet"}
            </td>
        </>
    );
};
